import axiosIns from '../../../../xaxios';
import {  obtenerUrlAPICalificaciones } from '../utils/funciones';
/**
 * @typedef {import('../interfaces/solicitud-modificacion-calificacion.Interfaces').FiltrosSolicitudesInterface} FiltrosSolicitudesInterface
 */
const recurso = 'reporte-nota';

export default {

  async getReportePlanillaNotasAcademico(dataInput) {
    const { programaModuloiId } = dataInput;
    return await axiosIns.get(
      obtenerUrlAPICalificaciones(`${recurso}/academico/${programaModuloiId}/planilla-notas`),
      { responseType: 'blob' },
    );
  },

  async getReporteActaNotasAcademico(dataInput) {
    const { programaModuloiId } = dataInput;
    return await axiosIns.get(
      obtenerUrlAPICalificaciones(`${recurso}/academico/${programaModuloiId}/acta-notas`),
      { responseType: 'blob' },
    );
  },

  async getReporteActaNotaSegundaInstanciaAcademico(dataInput) {
    const { programaModuloiId } = dataInput;
    return await axiosIns.get(
      obtenerUrlAPICalificaciones(`${recurso}/academico/${programaModuloiId}/acta-nota-segunda-instancia`),
      { responseType: 'blob' },
    );
  },

  async getReportePlanillaNotasPrimeraInstanciaAcademico(dataInput) {
    const { programaModuloiId } = dataInput;
    return await axiosIns.get(
      obtenerUrlAPICalificaciones(`${recurso}/academico/${programaModuloiId}/acta-nota-primera-instancia`),
      { responseType: 'blob' },
    );
  },

};
